import { DEFAULT_COMPANY_MAIL_TEMPLATES_FILTER } from 'constants/common'
import { getUniqueItem } from 'helpers/utils'
import CompanyTypes from 'store/actionTypes/company'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  systems: [],
  current: {},
  pagination: {},
  filter: {},
  members: {
    list: [],
    pagination: {}
  },
  childrenCompanies: {
    list: [],
    pagination: {}
  },
  pilots: {
    list: [],
    pagination: {}
  },
  vehicles: [],
  subscriptions: [],
  companyMailTemplates: {
    list: [],
    filter: DEFAULT_COMPANY_MAIL_TEMPLATES_FILTER
  },
  producedVehicle: {
    list: [],
    pagination: {}
  },
  companyVehicleWithoutLinks: []
}

const company = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case CompanyTypes.GET_COMPANIES_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }

    case CompanyTypes.GET_COMPANY_DETAIL_SUCCESS:
      return { ...state, current: payload }

    case CompanyTypes.GET_SHEET_ADDITIONAL_SUCCESS:
      return {
        ...state,
        current: {
          ...state.current,
          ...(payload?.company || {})
        }
      }

    // ======== COMPANY MEMBERS =========
    case CompanyTypes.GET_COMPANY_MEMBERS_SUCCESS:
      return {
        ...state,
        members: {
          list: payload?.items,
          pagination: payload?.meta
        }
      }

    // ======== CHILDREN COMPANIES =========
    case CompanyTypes.GET_CHILDREN_COMPANIES_SUCCESS:
      if (payload?.meta.currentPage === 1) {
        return {
          ...state,
          childrenCompanies: {
            list: payload?.items,
            pagination: payload?.meta
          }
        }
      }
      return {
        ...state,
        childrenCompanies: {
          list: getUniqueItem([
            ...(state.childrenCompanies.list || []),
            ...(payload?.items || [])
          ]),
          pagination: payload?.meta
        }
      }
    case CompanyTypes.UPDATE_FILTER_COMPANY_SUCCESS:
      return { ...state, filter: payload }
    case CompanyTypes.CLEAR_FILTER_COMPANY_SUCCESS:
      return { ...state, filter: initialData.filter }

    // ======== COMPANY PILOTS =========
    case CompanyTypes.GET_COMPANY_PILOTS_SUCCESS:
      return {
        ...state,
        pilots: {
          list: getUniqueItem([
            ...(state?.pilots?.list || []),
            ...(payload?.items || [])
          ]),
          pagination: payload?.meta
        }
      }
    // ======== COMPANY VEHICLES =========
    case CompanyTypes.GET_COMPANY_VEHICLES_SUCCESS:
      return { ...state, vehicles: payload?.items }
    case CompanyTypes.GET_COMPANY_SUBSCRIPTIONS_SUCCESS:
      return { ...state, subscriptions: payload?.items }

    case CompanyTypes.GET_SYSTEM_COMPANIES_SUCCESS: {
      return { ...state, systems: payload?.items }
    }

    case CompanyTypes.GET_COMPANY_MAIL_TEMPLATES_SUCCESS:
      return {
        ...state,
        companyMailTemplates: {
          ...state.companyMailTemplates,
          list: payload?.items
        }
      }

    case CompanyTypes.GET_COMPANY_MAIL_TEMPLATES_FAILED:
      return {
        ...state,
        companyMailTemplates: {
          ...state.companyMailTemplates,
          list: []
        }
      }

    case CompanyTypes.UPDATE_FILTER_COMPANY_MAIL_TEMPLATES_SUCCESS:
      return {
        ...state,
        companyMailTemplates: {
          ...state?.companyMailTemplates,
          list: initialData.companyMailTemplates.list,
          filter: payload
        }
      }
    case CompanyTypes.CLEAR_FILTER_COMPANY_MAIL_TEMPLATES_SUCCESS:
      return {
        ...state,
        companyMailTemplates: {
          ...state?.companyMailTemplates,
          list: initialData.companyMailTemplates.list,
          filter: DEFAULT_COMPANY_MAIL_TEMPLATES_FILTER
        }
      }

    case CompanyTypes.GET_PRODUCED_VEHICLES_SUCCESS:
      return {
        ...state,
        producedVehicle: {
          list: payload?.items || [],
          pagination: payload?.meta
        }
      }

    case CompanyTypes.GET_LIST_LINKABLE_VEHICLE_SUCCESS:
      return {
        ...state,
        companyVehicleWithoutLinks: payload?.items || []
      }

    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default company
